<template>
  <NuxtLink
    v-if="link?.url && link?.type"
    class="block"
    :to="link.url"
    :target="link.target"
    v-bind="$attrs"
  >
    <slot />
  </NuxtLink>
  <div
    v-else
    class="block"
  >
    <slot v-bind="$attrs" />
  </div>
</template>

<script lang="ts" setup>
defineComponent({
  name: 'LinkDefault',
});

interface Props {
  link: {
    type?: 'external' | 'download' | 'page';
    target?: '_parent' | '_top' | '_blank' | '_self';
    url?: string;
    name?: string;
    emphasis?: string;
    showLinkKiosk?: boolean;
    showLinkCatalog?: boolean;
  };
}

defineProps<Props>();
</script>
